import React from 'react';
import { T } from 'react-translator-component';
import { useKiosk } from '../hooks/useKiosk';


export const ErrorMessages = ({ errors, width, isOffgrid = false }) => {
    const { isKioskMode } = useKiosk();
    return (
        <>
            {errors && Object.keys(errors).length > 0 && (
                <div
                    style={{
                        flex: 1,
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        width: width ? width : '40%',
                        padding: 5,
                        textAlign: 'left',
                        padding: '10px',
                    }}
                    className={`${isKioskMode ? 'kiosk-error-messages' : ''}`}
                >
                    {Object.keys(errors)
                        .filter((field) => errors[field]) // Filtra los campos cuyo valor no es null o undefined
                        .map((field) => {
                            let customField = field;
                            if (isOffgrid) {
                                switch (customField) {
                                    case "dniIssueDate":
                                        customField = `${customField}-offgrid`;
                                        break;
                                }
                            }
                            return (
                                <div key={`key-${field}`} className="font-size-sm text-danger" style={{ color: '#DC3545' }}>
                                    - {T(`checkin.inputs.${customField}`)} {/* Traduce el nombre del campo */}
                                    {T(errors[field])} {/* Traduce el mensaje de error */}
                                    <br />
                                </div>
                            )
                        })}
                </div>
            )}
        </>
    );
};
